export default __webpack_public_path__ + "static/media/placeholder-product.599db735.jpg";